export default class SearchPopup {
  constructor() {
    this.$homePopup = $('.cancel');
  }

  searchPopup() {
    const $storys = $('.article-popup');
    this.$homePopup.click(() => {
      $(window).scrollTop(this.lastScrollPosition);
      $('html').removeClass('search-popup-is-visible');
      $storys.fadeOut(300);
    });
  }

  openPopup() {
    const $storys = $('.article-popup');
    const $openBtn = $('.js-toggle-advanced-search');
    $openBtn.click(() => {
      this.lastScrollPosition = $(window).scrollTop();
      $storys.fadeIn(300);
      $('html').addClass('search-popup-is-visible');
    });
  }

  init() {
    this.searchPopup();
    this.openPopup();
  }
}
